<app-navbar></app-navbar>

<br>

<div *ngIf="false" style="background-color:#f5f5f5;width:99%;" class="mx-auto d-block">
    <div class="container-fluid" style="width:99%">
        <div class="row" > 
            <div class="col-md-2">

            </div>
            <div class="col-md-8"  >
                <mat-card>
                <div class="col-md-10 px-0 " >
                    <p class="aetnaMainDiv" class="break-msg" style="word-break: break-word;"> 
                      You have already raised a request for this environment; please allow us some time to review your request. 
                        
                       <br> 
                       <br>
                       <br>
                       <br>
                       <button pButton type="button" label="Go Back to Apps" (click)="goBackToApps()"    class="ui-button-secondary" ></button>
                     
                    </p>
                  
                </div> 
            </mat-card>
            </div>
            <div class="col-md-2">

            </div>
        </div>
    </div>   
</div>


<div *ngIf="autoApprovalMsg" style="background-color:#f5f5f5;width:99%;" class="mx-auto d-block">
    <div class="container-fluid" style="width:99%">
        <div class="row" > 
            <div class="col-md-2">

            </div>
            <div class="col-md-8"  >
                <mat-card>
                <div class="col-md-10 px-0 ">
                    <p class="aetnaMainDiv" class="break-msg"> 
                       
                        Your subscription request has been approved.
                      <br>
                      <br> 
                      
                     

                    </p>
                </div> 
            </mat-card>
            </div>
            <div class="col-md-2">

            </div>
        </div>
    </div>   
</div>

